import React, { useRef, useState } from "react";
import {
  PrismicReusableContent,
  PrismicReusableContentDataBody,
  PrismicReusableContentDataBodyContentCarousel,
  PrismicReusableContentDataBodyRichTextV2,
  PrismicReusableContentDataBodyTextAndIcons,
  PrismicReusableContentDataBodyTextAndImage,
} from "../../types/graphql";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TextAndIcons from "../modules/text-and-icons";
import RichText from "../modules/rich-text";
import TextAndImage from "../modules/text-and-image";

export type ICarouselProps = {
  slice: PrismicReusableContentDataBodyContentCarousel;
};

const Carousel = (props: ICarouselProps) => {
  const { slice } = props;
  const { primary } = slice;

  const doc = primary?.content?.document as PrismicReusableContent;
  const body = doc?.data?.body as PrismicReusableContentDataBody[];

  // Slick Slider
  const sliderRef = useRef<Slider>(null);
  const [sliderInitialized, setSliderInitialized] = useState(false);
  const settings = {
    arrows: false,
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    onInit: () => setSliderInitialized(true),
  };

  return (
    <>
      <PrismicRichText
        field={primary?.primary_heading?.richText}
        components={htmlSerializer}
      />
      <Slider ref={sliderRef} {...settings}>
        {sliderInitialized &&
          body?.map((item) => {
            console.log("[carousel] item", item);
            switch (item?.slice_type) {
              case "rich_text_v2":
                const richTextSlice =
                  item as PrismicReusableContentDataBodyRichTextV2;
                return <RichText slice={richTextSlice} />;
              case "text_and_icons":
                const textAndIcons =
                  item as PrismicReusableContentDataBodyTextAndIcons;
                return <TextAndIcons slice={textAndIcons} />;
              case "text_and_image":
                const textAndImage =
                  item as PrismicReusableContentDataBodyTextAndImage;
                return <TextAndImage slice={textAndImage} />;
              default:
                return <></>;
            }
          })}
      </Slider>
    </>
  );
};

export default Carousel;
